export default {"src":"/_next/static/media/arrow-illo-down.7f6657dc.svg","height":22,"width":25};